export default __webpack_public_path__ + "static/media/Standard-Procedure-Nate-Baldwin.8334235d.jpg";